import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './home-page.component';
import { homePageResolver } from './resolvers/home-page.resolver';
import { getEventCategoryForRouteParam } from './utility/route-utils';

const routes: Routes = [
  {
    matcher: (url) => {
      if(url.length === 0) {
        return { consumed: url };
      }

      if(url.length === 1) {
        const segment = url[0];
        const routeParam = segment.path;
        const category = getEventCategoryForRouteParam(routeParam);

        if(category !== null) {
          return {
            consumed: url,
            posParams: {
              category: segment,
            }
          };
        }
      }

      return null;
    },
    component: HomePageComponent,
    resolve: {
      homePageInfoSnapshot: homePageResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomePageRoutingModule { }
